<nav class="app-navbar">
  <div class="app-navbar-inner">
    <a class="app-navbar-brand" routerLink="/">
      <span class="brand-dot"></span>
      Disinformation&nbsp;Detector
    </a>

    <button class="app-navbar-toggle" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      ☰
    </button>

    <!--
    <div class="app-navbar-links" id="navbarSupportedContent">
      <ul class="left-links">
        <li class="nav-item">
          @if (authService.isLoggedIn()) {
          <a class="nav-link" routerLink="/message" routerLinkActive="active">Messages</a>
          }
        </li>
        <li class="nav-item">
          @if (authService.isLoggedIn()) {
          <a class="nav-link" routerLink="/analysis" routerLinkActive="active">Analyse</a>
          }
        </li>
      </ul>

      <ul class="right-links">
        @if (!authService.isLoggedIn()) {
        <a class="nav-link primary-link" routerLink="/login" routerLinkActive="active">Login</a>
        }
        @if (authService.isLoggedIn()) {
        <a class="nav-link" routerLink="/" (click)="authService.logoutUser()">Logout</a>
        }
      </ul>
    </div>
    !-->
  </div>

</nav>
